var cancelData = [
  {
    'belongName': ' 车金融',
    'riskCode': 'C101',
    'riskName': '客户认为放款时间过长',
    'status': '1'
  },
  {
    'belongName': ' 车金融',
    'riskCode': 'C102',
    'riskName': '客户不符合贷款条件（仅指军人、年龄超限、身体条件不适合开车、未学车无驾照等）',
    'status': '1'
  },
  {
    'belongName': ' 车金融',
    'riskCode': 'C103',
    'riskName': '客户无法提供担保人,或者客户不接受加担保人',
    'status': '1'
  },
  {
    'belongName': ' 车金融',
    'riskCode': 'C104',
    'riskName': '等待客户提供资料时间过长、退回经销商时间过长（3天以上）',
    'status': '1'
  },
  {
    'belongName': ' 车金融',
    'riskCode': 'C105',
    'riskName': '客户认为流程太复杂',
    'status': '1'
  },
  {
    'belongName': ' 车金融',
    'riskCode': 'C106',
    'riskName': '客户因我司服务质量不满意，取消贷款',
    'status': '1'
  },
  {
    'belongName': ' 车金融',
    'riskCode': 'C107',
    'riskName': '客户不符合产品要求（5050, Young Plan或者其他促销产品）',
    'status': '1'
  },
  {
    'belongName': ' 车金融',
    'riskCode': 'C108',
    'riskName': '地区偏远，家访员无法进行家访',
    'status': '1'
  },
  {
    'belongName': ' 车金融',
    'riskCode': 'C109',
    'riskName': '促销产品下线',
    'status': '1'
  },
  {
    'belongName': 'Dealer',
    'riskCode': 'C201',
    'riskName': '经销商无车源或没有客户所要车型或颜色,客户放弃或者更换经销商改购其它品牌车辆',
    'status': '1'
  },
  {
    'belongName': 'Dealer',
    'riskCode': 'C202',
    'riskName': '初审不合格退回经销商后，一个月内没有重新提交',
    'status': '1'
  },
  {
    'belongName': 'Dealer',
    'riskCode': 'C203',
    'riskName': '经销商业务暂停',
    'status': '1'
  },
  {
    'belongName': 'Dealer',
    'riskCode': 'C204',
    'riskName': '经销商提供的产品\车价\其它收费\经销商服务客户不满意、无法接受',
    'status': '1'
  },
  {
    'belongName': 'Dealer',
    'riskCode': 'C205',
    'riskName': 'SP经销商开票问题或者经销商无资格销售该品牌车辆',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C301',
    'riskName': '客户认为利率太高',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C302',
    'riskName': '客户无力支付首付款',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C303',
    'riskName': '更换主贷人',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C304',
    'riskName': '长期联系不上（例：出差，手机关机等）',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C305',
    'riskName': '客户隐瞒配偶购车，拒绝添加配偶信息',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C306',
    'riskName': '客户配偶或者担保人因在外地等情况无法签署合同',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C307',
    'riskName': '我司要求提供的资料，客户无法提供或不愿提供',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C308',
    'riskName': '客户放弃购车行为',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C309',
    'riskName': '客户因其他原因选择银行/信用卡/担保公司等其它车贷渠道',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C310',
    'riskName': '经销商发现客户存在代购/提供假资料等欺诈行为,为控制风险,取消客户申请',
    'status': '1'
  },
  {
    'belongName': 'System',
    'riskCode': 'C901',
    'riskName': '重复申请(客户本人有历史申请纪录)',
    'status': '1'
  },
  {
    'belongName': 'System',
    'riskCode': 'C902',
    'riskName': '重复申请(配偶有历史申请纪录)',
    'status': '1'
  },
  {
    'belongName': 'System',
    'riskCode': 'C903',
    'riskName': '特殊原因系统做批量取消',
    'status': '1'
  },
  {
    'belongName': 'Used Car',
    'riskCode': 'C401',
    'riskName': '车辆不符合贷款条件（车辆改装，车龄超5年，公里数超12万公里，过户超2个月等）',
    'status': '1'
  },
  {
    'belongName': 'Used Car',
    'riskCode': 'C402',
    'riskName': 'RB系统无对应车型或对应评估价',
    'status': '1'
  },
  {
    'belongName': 'Dealer',
    'riskCode': 'C206',
    'riskName': '客户要求太多，经销商不愿意卖车',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C311',
    'riskName': '贷款少批',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C312',
    'riskName': '客户全款购车',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C313',
    'riskName': '手续费，平台费过高，客户无法接受',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C314',
    'riskName': '不认可GPS费用',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C315',
    'riskName': '车辆有问题（事故车，问题车，水泡车等）',
    'status': '1'
  },
  {
    'belongName': 'Customer',
    'riskCode': 'C316',
    'riskName': '担保人不同意购车',
    'status': '1'
  },
  {
    'belongName': ' 车金融',
    'riskCode': 'C110',
    'riskName': '客户名下有报废车',
    'status': '1'
  }
]

var refuseData = [
  {
    'belongName': '信用类',
    'riskCode': 'R11',
    'riskName': '我司还款逾期',
    'status': '1'
  },
  {
    'belongName': '信用类',
    'riskCode': 'R12',
    'riskName': '主贷人信用违约',
    'status': '1'
  },
  {
    'belongName': '信用类',
    'riskCode': 'R13',
    'riskName': '配偶信用违约',
    'status': '1'
  },
  {
    'belongName': '信用类',
    'riskCode': 'R14',
    'riskName': '担保人/实际用车人信用记录违约',
    'status': '1'
  },
  {
    'belongName': '信用类',
    'riskCode': 'R15',
    'riskName': 'CBRC on match',
    'status': '1'
  },
  {
    'belongName': '信用类',
    'riskCode': 'R16',
    'riskName': '信贷决定后信用记录出现违约',
    'status': '1'
  },
  {
    'belongName': '工作收入类',
    'riskCode': 'R21',
    'riskName': '收入水平与稳定性欠佳',
    'status': '1'
  },
  {
    'belongName': '工作收入类',
    'riskCode': 'R22',
    'riskName': '工作信息难以核实',
    'status': '1'
  },
  {
    'belongName': '工作收入类',
    'riskCode': 'R24',
    'riskName': '收入来源不详',
    'status': '1'
  },
  {
    'belongName': '工作收入类',
    'riskCode': 'R25',
    'riskName': '家庭负债较高，收入不足以承受',
    'status': '1'
  },
  {
    'belongName': '工作收入类',
    'riskCode': 'R26',
    'riskName': '收入合法性难以确认',
    'status': '1'
  },
  {
    'belongName': '经营收入类（针对私营业主）',
    'riskCode': 'R31',
    'riskName': '收入水平与稳定性欠佳',
    'status': '1'
  },
  {
    'belongName': '经营收入类（针对私营业主）',
    'riskCode': 'R32',
    'riskName': '收入来源不详',
    'status': '1'
  },
  {
    'belongName': '经营收入类（针对私营业主）',
    'riskCode': 'R34',
    'riskName': '家庭负债较高，收入不足以承受',
    'status': '1'
  },
  {
    'belongName': '经营收入类（针对私营业主）',
    'riskCode': 'R35',
    'riskName': '高风险行业/收入合法性难以确认',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R51',
    'riskName': '代购',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R52',
    'riskName': '盗用他人身份证申请',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R53',
    'riskName': '使用虚假身份证申请',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R54',
    'riskName': '使用不存在的“壳”公司申请贷款',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R55',
    'riskName': '收入造假',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R56',
    'riskName': '职业造假',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R57',
    'riskName': '交易车辆背景复杂/交易不实',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R5A',
    'riskName': '信贷评分造假',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R5B',
    'riskName': '车辆设备加装造假',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R5C',
    'riskName': '员工购车舞弊',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R5D',
    'riskName': '滥用信贷',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R5E',
    'riskName': '“环形圈”舞弊',
    'status': '1'
  },
  {
    'belongName': '欺诈类',
    'riskCode': 'R5F',
    'riskName': '其他资料造假',
    'status': '1'
  },
  {
    'belongName': '违反政策类',
    'riskCode': 'R71',
    'riskName': '购车用于租赁/营运',
    'status': '1'
  },
  {
    'belongName': '违反政策类',
    'riskCode': 'R72',
    'riskName': '不良生活习惯',
    'status': '1'
  },
  {
    'belongName': '违反政策类',
    'riskCode': 'R73',
    'riskName': '犯罪纪录',
    'status': '1'
  },
  {
    'belongName': '违反政策类',
    'riskCode': 'R74',
    'riskName': '最高法院执行记录',
    'status': '1'
  },
  {
    'belongName': '其他',
    'riskCode': 'R61',
    'riskName': '不配合电话核查',
    'status': '1'
  },
  {
    'belongName': '其他',
    'riskCode': 'R62',
    'riskName': '贷后管理困难',
    'status': '1'
  },
  {
    'belongName': '其他',
    'riskCode': 'R63',
    'riskName': '不接受有条件核准',
    'status': '1'
  },
  {
    'belongName': '其他',
    'riskCode': 'R64',
    'riskName': '实际用车人/还款人为配偶且婚姻关系复杂',
    'status': '1'
  },
  {
    'belongName': '其他',
    'riskCode': 'R65',
    'riskName': '实际用车人/还款人为配偶且其不支持购车',
    'status': '1'
  },
  {
    'belongName': '其他',
    'riskCode': 'R67',
    'riskName': '担保人不知道担保事宜/不同意担保',
    'status': '1'
  },
  {
    'belongName': '违反政策类',
    'riskCode': 'R0J',
    'riskName': '京东验证不通过',
    'status': '1'
  },
  {
    'belongName': '违反政策类',
    'riskCode': 'R0H',
    'riskName': '华昌验证不通过',
    'status': '1'
  }
]

var backData = [
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D101',
    'riskName': '征信未勾选/错误',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D102',
    'riskName': '车辆信息错误/未录全',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D103',
    'riskName': '卖方信息错误',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D104',
    'riskName': '未接听回访电话',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D105',
    'riskName': '资料不全',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D106',
    'riskName': '资料不清晰',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D107',
    'riskName': '平台费未勾选/错误',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D108',
    'riskName': '车辆贷款金额错误',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D109',
    'riskName': '上传附件错误',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D110',
    'riskName': '合同内信息有误',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D111',
    'riskName': '人员信息错误（主贷人，紧急联系人，配偶）',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D112',
    'riskName': '销售未留联系方式',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D113',
    'riskName': '保单不符合要求',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D114',
    'riskName': '合同签字不符合要求',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D115',
    'riskName': '银联卡信息在系统或者合同有误',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D116',
    'riskName': '抵押渠道有误',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D117',
    'riskName': '其他',
    'status': '1'
  },
  {
    'belongName': '风控退回修改类',
    'riskCode': 'D118',
    'riskName': '非人工差错退回',
    'status': '1'
  }
]

var passData = [
  {
    'belongName': '全额批复',
    'riskCode': 'AA',
    'riskName': '全额批复',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA11',
    'riskName': '信用记录瑕疵',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA12',
    'riskName': '信用记录时间短',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA13',
    'riskName': '无信用记录',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA21',
    'riskName': '收入水平与稳定性有限',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA23',
    'riskName': '家庭负债较高，收入不足以承受',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA31',
    'riskName': '经营规模和稳定性有限',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA33',
    'riskName': '家庭负债较高，收入不足以承受',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA41',
    'riskName': '单身/年轻',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA42',
    'riskName': '本地无自有房产',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA44',
    'riskName': '特殊产品和高价车要求',
    'status': '1'
  },
  {
    'belongName': '有条件批复',
    'riskCode': 'QA46',
    'riskName': '不考虑配偶的资信情况，由R变Q',
    'status': '1'
  },
  {
    'belongName': '特批',
    'riskCode': 'TA',
    'riskName': '特批',
    'status': '1'
  },
  {
    'belongName': '复议通过',
    'riskCode': 'FA1',
    'riskName': '经销商复议',
    'status': '1'
  },
  {
    'belongName': '复议通过',
    'riskCode': 'FA2',
    'riskName': '销售复议',
    'status': '1'
  },
  {
    'belongName': '复议通过',
    'riskCode': 'FA3',
    'riskName': '销售总监复议',
    'status': '1'
  }
]

export {
  cancelData,
  refuseData,
  backData,
  passData
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.data.reasons.js